import script from "./ComicCover.vue?vue&type=script&setup=true&lang=js"
export * from "./ComicCover.vue?vue&type=script&setup=true&lang=js"

import "@/shared/styles/ComicCover.css?vue&type=style&index=0&id=054370ee&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-054370ee"]])

export default __exports__